import { useEffect, useState } from 'react'
import { Check, Loader2, Mail, RefreshCw, ShieldCheck, TriangleAlert } from 'lucide-react'
import { api } from './api'
import { Notice, Page, StatusPill } from './ui'
import { AuthFrame } from './AuthPages'
import type { ServiceStatus } from './appTypes'
import { Link } from './navigation'

export function StatusPage() {
  const [status, setStatus] = useState<ServiceStatus | null>(null)
  const [failed, setFailed] = useState(false)
  const check = () => {
    setStatus(null); setFailed(false)
    api<ServiceStatus>('/api/v1/status').then(setStatus).catch(() => setFailed(true))
  }
  useEffect(check, [])
  const mailConfigured = status?.mail === 'configured_not_tested'
  const accountAccessAvailable = status?.core === 'available'
  return <AuthFrame title="Service status" description="Current status of account access and sign-in email.">
    {failed && <Notice tone="error">We could not check service status. Try again.</Notice>}
    {!status && !failed && <div className="status-loading" role="status"><Loader2 className="spin" /><span>Checking status…</span></div>}
    {status && <div className="status-list">
      <div className={`status-row ${accountAccessAvailable ? '' : 'failed'}`}>{accountAccessAvailable ? <ShieldCheck /> : <TriangleAlert />}<div><strong>Account access</strong><span>{accountAccessAvailable ? 'AuthEM can process sign-in requests.' : 'AuthEM cannot process sign-in requests right now.'}</span></div><StatusPill value={accountAccessAvailable ? 'Available' : 'Unavailable'} /></div>
      <div className="status-row"><Mail /><div><strong>Sign-in email</strong><span>{mailConfigured ? 'Delivery is set up, but this check does not send a test email.' : 'Email is captured for testing and is not delivered.'}</span></div><StatusPill value={mailConfigured ? 'Not tested' : 'Test mode'} /></div>
    </div>}
    <button className="button secondary full" onClick={check}><RefreshCw size={17} /> Check again</button>
  </AuthFrame>
}

export function NotFound() { return <AuthFrame title="Page not found" description="The address may be incorrect or the page may have moved."><Link className="button primary full" to="/login">Return to sign in</Link></AuthFrame> }
